export default __webpack_public_path__ + "static/competitor_vector-e0c331de63258fcf3e66613bc9610b0f.svg";